import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const GymSection = () => {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="gym" className="mgs-gym">
      <div className="mgs-gym__inner">
        <div className="mgs-gym__text">
          <h2 className="mgs-gym__title">
            <span className="mgs-gym__title-line">Só academia</span>
            <span className="mgs-gym__title-line">não é</span>
            <span className="mgs-gym__title-line mgs-gym__title-gold">suficiente.</span>
          </h2>

          <p className="mgs-gym__desc">
            Na prática, quem já frequenta a academia sabe que existem desafios como{' '}
            <strong>fome, compulsão, retenção de líquidos e metabolismo lento</strong>.
          </p>

          <p className="mgs-gym__desc">
            Por isso, pessoas com estilo de vida completamente diferentes, desde quem
            não consegue manter uma rotina de treinos até quem já pratica atividade
            física regularmente, <strong>incluem o MagriSim como um aliado na sua
            jornada de emagrecimento</strong>.
          </p>

          <p className="mgs-gym__desc">
            Afinal, cada pessoa está em um momento diferente, mas todas têm o mesmo
            objetivo: <strong>conquistar um corpo mais bonito e saudável</strong>.
          </p>

          <button className="mgs-gym__cta" onClick={scrollToOffer}>
            <i className="fas fa-tint"></i>
            QUERO EMAGRECER AGORA
          </button>
        </div>

        <div className="mgs-gym__image">
          <img
            src={IMAGE_PATHS.mulherAcademia}
            alt="Mulher em forma após o treino"
            className="mgs-gym__img"
          />
        </div>
      </div>
    </section>
  );
};

export default GymSection;
